export default __webpack_public_path__ + "images/assets/73154f85d6663268b44e363da43fe5c1.svg";